import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShipmentMiniEntity } from '../../domain/entities/ShipmentMiniEntity'
import type { ShipmentAdminListedDtoAdmin } from '@/backend/market'

export class ShipmentMiniModel extends ShipmentMiniEntity {
  constructor(dataDto: ShipmentAdminListedDtoAdmin) {
    super()
    mapEntityProperties<ShipmentMiniModel>(this, dataDto)
  }
}
